import { FormValidationType } from "../../../../types";
import { PRODUCT_INFORMATION_CONSTANTS } from "../../../constants";

export const formFieldsValidation: FormValidationType = {
  [PRODUCT_INFORMATION_CONSTANTS.COUNTRY_WHERE_ITEM_WAS_PURCHASED]: {
    required: { value: true },
  },
  [PRODUCT_INFORMATION_CONSTANTS.ORDER_ID]: {
    required: { value: true },
  },
  [PRODUCT_INFORMATION_CONSTANTS.ASIN]: {
    required: { value: true },
  },
  [PRODUCT_INFORMATION_CONSTANTS.PRODUCT_NAME]: {
    required: { value: true },
  },
  [PRODUCT_INFORMATION_CONSTANTS.FULFILMENT_PATH]: {
    required: { value: true },
  },
};